import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	showChecklist: false
};

const designUpdateSlice = createSlice({
	name: 'techpackDesignUpdate',
	initialState,
	reducers: {
		setShowCheckList: (state, { payload }) => {
			state.showChecklist = payload;
		}
	}
});

export const { setShowCheckList } = designUpdateSlice.actions;

export default designUpdateSlice.reducer;
